import makeFormRequest from "../../../../helpers/form-request.js";
import ServerResponse from "../../../../helpers/render-server-response.js";
import Request from "../../../../helpers/request.js";
export default {
    execute: async (data) => {
        const { id, form, submitBtn } = data;
        const payload = {
            id,
            date: form.showdate.value,
            venue: form.venue.value.trim(),
            location: form.location.value.trim(),
            link: form.link.value.trim(),
            soldOut: form.soldout.checked
        };
        const formRequest = makeFormRequest({ form, submitBtn });
        const response = await Request.post('/shows/update', payload);
        formRequest.afterResponse(false);
        if (response.success) {
            ServerResponse.show({
                resp: response,
                respTitle: 'SUCCESS',
                respText: `Show updated successfully.`
            });
            return;
        }
        ServerResponse.show({
            resp: response,
            respTitle: 'ERROR',
            respText: response.error
        });
    }
};
